/**
 * Element sections data for the form builder
 * Each section contains a title and array of element items
 */

export const elementSections = {
  layout: {
    title: 'Layout',
    elements: [
      {
        type: 'section-header',
        label: 'Section Header',
        iconSvg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 5V3H21V5H3ZM19 7C19.55 7 20.0208 7.19583 20.4125 7.5875C20.8042 7.97917 21 8.45 21 9V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V9C3 8.45 3.19583 7.97917 3.5875 7.5875C3.97917 7.19583 4.45 7 5 7H19ZM19 9H5V19H19V9Z" fill="#374957"/>
        </svg>`
      },
      {
        type: 'clinic-branding',
        label: 'Clinic Branding Header',
        iconSvg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.03 5.8H11.97L10.95 8.69H13.05L12.03 5.8Z" fill="#374957"/>
          <path d="M5 16.5H3V21.5H5V16.5Z" fill="#374957"/>
          <path d="M12 14.5C15.31 14.5 18 11.81 18 8.5C18 5.19 15.31 2.5 12 2.5C8.69 2.5 6 5.19 6 8.5C6 11.81 8.69 14.5 12 14.5ZM11.37 4.5H12.62L15.25 11.5H14.04L13.41 9.71H10.58L9.96 11.5H8.74L11.37 4.5Z" fill="#374957"/>
          <path d="M9 16.5H7V21.5H9V16.5Z" fill="#374957"/>
          <path d="M13 16.5H11V21.5H13V16.5Z" fill="#374957"/>
          <path d="M21 16.5H15V21.5H21V16.5Z" fill="#374957"/>
        </svg>`
      },
      {
        type: 'note-help',
        label: 'Note / Help Message',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M19 1.5H5C3.89 1.5 3 2.4 3 3.5V17.5C3 18.6 3.89 19.5 5 19.5H9L12 22.5L15 19.5H19C20.1 19.5 21 18.6 21 17.5V3.5C21 2.4 20.1 1.5 19 1.5ZM19 17.5H14.17L12 19.67L9.83 17.5H5V3.5H19V17.5ZM11 14.5H13V16.5H11V14.5ZM12 6.5C13.1 6.5 14 7.4 14 8.5C14 10.5 11 10.25 11 13.5H13C13 11.25 16 11 16 8.5C16 6.29 14.21 4.5 12 4.5C9.79 4.5 8 6.29 8 8.5H10C10 7.4 10.9 6.5 12 6.5Z" fill="#374957"/>
        </svg>`
      },
      {
        type: 'image',
        label: 'Image',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M21 3H3C2 3 1 4 1 5V19C1 20.1 1.9 21 3 21H21C22 21 23 20 23 19V5C23 4 22 3 21 3ZM21 18.92C20.98 18.95 20.94 18.98 20.92 19H3V5.08L3.08 5H20.91C20.94 5.02 20.97 5.06 20.99 5.08V18.92H21ZM11 15.51L8.5 12.5L5 17H19L14.5 11L11 15.51Z" fill="#374957"/>
        </svg>`
      }
    ]
  },
  textInputs: {
    title: 'Text Inputs',
    elements: [
      {
        type: 'short-response',
        label: 'Short Response',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M4 9H20V11H4V9ZM4 13H14V15H4V13Z" fill="#374957"/>
        </svg>`
      },
      {
        type: 'long-response',
        label: 'Long Response',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M14 17H4V19H14V17ZM20 9H4V11H20V9ZM4 15H20V13H4V15ZM4 5V7H20V5H4Z" fill="#374957"/>
        </svg>`
      },
      {
        type: 'description',
        label: 'Description / Instructions',
        iconSvg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18ZM6 10H8V12H6V10ZM6 14H14V16H6V14ZM16 14H18V16H16V14ZM10 10H18V12H10V10Z" fill="#374957"/>
        </svg>`
      }
    ]
  },
  contactInfo: {
    title: 'Contact Info',
    elements: [
      {
        type: 'email',
        label: 'Email',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22H17V20H12C7.66 20 4 16.34 4 12C4 7.66 7.66 4 12 4C16.34 4 20 7.66 20 12V13.43C20 14.22 19.29 15 18.5 15C17.71 15 17 14.22 17 13.43V12C17 9.24 14.76 7 12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C13.38 17 14.64 16.44 15.54 15.53C16.19 16.42 17.31 17 18.5 17C20.47 17 22 15.4 22 13.43V12C22 6.48 17.52 2 12 2ZM12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15Z" fill="#374957"/>
        </svg>`
      },
      {
        type: 'phone',
        label: 'Phone Number',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z" fill="#374957"/>
        </svg>`
      }
    ]
  },
  selectionInputs: {
    title: 'Selection Inputs',
    elements: [
      {
        type: 'single-selection',
        label: 'Single Selection',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="#374957"/>
          <path d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z" fill="#374957"/>
        </svg>`
      },
      {
        type: 'multi-selection',
        label: 'Multiple Selection',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M22 7.53497H13V9.53497H22V7.53497ZM22 15.535H13V17.535H22V15.535ZM5.54 11.535L2 7.99497L3.41 6.58497L5.53 8.70497L9.77 4.46497L11.18 5.87497L5.54 11.535ZM5.54 19.535L2 15.995L3.41 14.585L5.53 16.705L9.77 12.465L11.18 13.875L5.54 19.535Z" fill="#374957"/>
        </svg>`
      },
      {
        type: 'checkbox',
        label: 'Checkbox',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM17.99 9L16.58 7.58L9.99 14.17L7.41 11.6L5.99 13.01L9.99 17L17.99 9Z" fill="#374957"/>
        </svg>`
      },
      {
        type: 'dropdown',
        label: 'Single-selection Dropdown',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 15L8 11H16L12 15Z" fill="#374957"/>
        </svg>`
      },
      {
        type: 'yes-no',
        label: 'Yes / No',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M16.45 11.035L12.91 7.49497L14.32 6.08497L16.44 8.20497L20.68 3.96497L22.09 5.37497L16.45 11.035ZM10.91 7.03497H1.91003V9.03497H10.91V7.03497ZM20.91 13.445L19.5 12.035L16.91 14.625L14.32 12.035L12.91 13.445L15.5 16.035L12.91 18.625L14.32 20.035L16.91 17.445L19.5 20.035L20.91 18.625L18.32 16.035L20.91 13.445ZM10.91 15.035H1.91003V17.035H10.91V15.035Z" fill="#374957"/>
        </svg>`
      }
    ]
  },
  specializedInputs: {
    title: 'Specialized Inputs',
    elements: [
      {
        type: 'date',
        label: 'Date',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M7 11H9V13H7V11ZM21 6V20C21 21.1 20.1 22 19 22H5C3.89 22 3 21.1 3 20L3.01 6C3.01 4.9 3.89 4 5 4H6V2H8V4H16V2H18V4H19C20.1 4 21 4.9 21 6ZM5 8H19V6H5V8ZM19 20V10H5V20H19ZM15 13H17V11H15V13ZM11 13H13V11H11V13Z" fill="#374957"/>
        </svg>`
      },
      {
        type: 'datetime',
        label: 'Date & Time',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M19 6.5H18V1.5H6V6.5H5C3.9 6.5 3 7.4 3 8.5V20.5C3 21.6 3.9 22.5 5 22.5H19C20.1 22.5 21 21.6 21 20.5V8.5C21 7.4 20.1 6.5 19 6.5ZM8 3.5H16V6.5H8V3.5ZM19 20.5H5V8.5H19V20.5Z" fill="#374957"/>
          <path d="M12 9.5C9.24 9.5 7 11.74 7 14.5C7 17.26 9.24 19.5 12 19.5C14.76 19.5 17 17.26 17 14.5C17 11.74 14.76 9.5 12 9.5ZM12 18C10.07 18 8.5 16.43 8.5 14.5C8.5 12.57 10.07 11 12 11C13.93 11 15.5 12.57 15.5 14.5C15.5 16.43 13.93 18 12 18Z" fill="#374957"/>
          <path d="M12.5 12H11.5V14.71L13.14 16.35L13.85 15.64L12.5 14.29V12Z" fill="#374957"/>
        </svg>`
      },
      {
        type: 'time',
        label: 'Time',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" fill="#374957"/>
        </svg>`
      },
      {
        type: 'numeric',
        label: 'Numeric',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M7.25 15H5.75V10.5H4.25V9H7.25V15ZM13.75 13.5H10.75V12.5H12.75C13.3 12.5 13.75 12.05 13.75 11.5V10C13.75 9.45 13.3 9 12.75 9H9.25V10.5H12.25V11.5H10.25C9.7 11.5 9.25 11.95 9.25 12.5V15H13.75V13.5ZM19.75 14V10C19.75 9.45 19.3 9 18.75 9H15.25V10.5H18.25V11.5H16.25V12.5H18.25V13.5H15.25V15H18.75C19.3 15 19.75 14.55 19.75 14Z" fill="#374957"/>
        </svg>`
      },
      {
        type: 'rating',
        label: 'Rating Scale',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M22 9.74L14.81 9.12L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77L18.18 21.5L16.55 14.47L22 9.74ZM12 15.9V6.6L13.71 10.64L18.09 11.02L14.77 13.9L15.77 18.18L12 15.9Z" fill="#374957"/>
        </svg>`
      },
      {
        type: 'signer',
        label: 'Signer',
        iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M19.1024 10.39L20.1624 9.33C20.9424 8.55 20.9424 7.28 20.1624 6.5L18.7524 5.09C17.9724 4.31 16.7024 4.31 15.9224 5.09L14.8624 6.15L19.1024 10.39ZM14.8624 11.81L7.66244 19H6.25244V17.59L13.4424 10.4L14.8624 11.81ZM13.4424 7.56L4.25244 16.76V21H8.49244L17.6824 11.81L13.4424 7.56ZM19.2524 17.5C19.2524 19.69 16.7124 21 14.2524 21C13.7024 21 13.2524 20.55 13.2524 20C13.2524 19.45 13.7024 19 14.2524 19C15.7924 19 17.2524 18.27 17.2524 17.5C17.2524 17.03 16.7724 16.63 16.0224 16.3L17.5024 14.82C18.5724 15.45 19.2524 16.29 19.2524 17.5ZM4.83244 13.35C3.86244 12.79 3.25244 12.06 3.25244 11C3.25244 9.2 5.14244 8.37 6.81244 7.64C7.84244 7.18 9.25244 6.56 9.25244 6C9.25244 5.59 8.47244 5 7.25244 5C5.99244 5 5.45244 5.61 5.42244 5.64C5.07244 6.05 4.44244 6.1 4.02244 5.76C3.61244 5.42 3.53244 4.81 3.87244 4.38C3.98244 4.24 5.01244 3 7.25244 3C9.49244 3 11.2524 4.32 11.2524 6C11.2524 7.87 9.32244 8.72 7.61244 9.47C6.67244 9.88 5.25244 10.5 5.25244 11C5.25244 11.31 5.68244 11.6 6.32244 11.86L4.83244 13.35Z" fill="#374957"/>
        </svg>`
      }
    ]
  }
};

/**
 * Get all sections as an array for rendering
 */
export function getSectionsArray() {
  return Object.entries(elementSections).map(([key, section]) => ({
    key,
    ...section
  }));
}

/**
 * Get elements for a specific section
 */
export function getSectionElements(sectionKey) {
  return elementSections[sectionKey]?.elements || [];
}

/**
 * Add a new element to a section
 */
export function addElementToSection(sectionKey, element) {
  if (elementSections[sectionKey]) {
    elementSections[sectionKey].elements.push(element);
  }
}

/**
 * Remove an element from a section by type
 */
export function removeElementFromSection(sectionKey, elementType) {
  if (elementSections[sectionKey]) {
    elementSections[sectionKey].elements = elementSections[sectionKey].elements.filter(
      el => el.type !== elementType
    );
  }
}

export default elementSections;
